var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"label":_vm.label,"loading":_vm.loading,"items":_vm.items,"search-input":_vm.search,"clearable":"","hide-no-data":"","hide-details":_vm.hideDetails,"item-text":"nazev","item-id":"id","return-object":""},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
var selected = ref.selected;
return [_c('span',{domProps:{"textContent":_vm._s(item.nazev)}})]}},{key:"item",fn:function(ref){
var item = ref.item;
var tile = ref.tile;
return [_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.nazev))])],1)]}}]),model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c44b99f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SporiciCilovyProduktSearch.vue
// module id = null
// module chunks = 